module.exports = __webpack_public_path__ + "img/framePassport.3410ca48.png";